// Mock utility for authenticating FileManager
export const fileManagerInitialize = (): string => {
  // Set from local.settings.json
  return 'ONEDRIVE_TOKEN';
};
